import {
    RichTableColumns,
} from 'app/types/richtable.types'

import {
    CommentType,
} from './CommentsLog.types'

const getColumns = (
    l: (key:string)=> string, sorting: boolean,
): RichTableColumns<keyof CommentType>[] => {
    return [
        {
            id: 'createdBy',
            headerProps: {
                children: l('OrderComment.createdBy'),
                sorting,
            },
            mapCellProps: 'createdBy',
        },
        {
            id: 'comment',
            headerProps: {
                children: l('OrderComment.comment'),
                sorting,
            },
            mapCellProps: 'comment',
        },
        {
            id: 'createdOn',
            headerProps: {
                children: l('OrderComment.createdOn'),
                sorting,
            },
            mapCellProps: 'changedOn',
            componentName: 'DateTimeCell',
        },
        {
            id: 'delete',
            headerProps: {
                children: '',
            },
            mapCellProps: 'delete',
            width: '50px',
            componentName: 'RemoveComment',
        },
    ]
}

export default getColumns
